import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import {
  useDashboardPhaseOrderScan,
  useDetailPhaseOrder,
  useListPhaseOrderScanActionType,
  useListPhaseOrderScanStatus,
} from "hooks/order-scan/useOrderScan";
import ListHistoryScan from "pages/HistoryScanTheRow/ListHistoryScan";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Col, Container, Input, Label, Row } from "reactstrap";
import DonutChart from "../Chart/DonutChart";

const PhaseOrderDetailPage = props => {
  const { t } = useTranslation(["order"]);
  const navigate = useNavigate();

  const pageParams = useParams();
  const { phaseOrderScanDetailId } = pageParams;

  const [dashboardData, setDashboardData] = useState([]);
  const {
    mutate: mutateDashboardPhaseOrderScan,
    isLoading: isLoadingDashboardPhaseOrderScan,
  } = useDashboardPhaseOrderScan({
    onSuccess: data => {
      setDashboardData(data || []);
    },
    onError: () => {},
  });

  // order detail history
  const {
    refetch: fetchOrderDetailPhaseOrder,
    data: dataDetailPhaseOrder,
    isLoading,
  } = useDetailPhaseOrder({ id: phaseOrderScanDetailId });

  const {
    refetch: fetchListPhaseOrderScanStatus,
    data: listPhaseOrderScanStatus,
  } = useListPhaseOrderScanStatus({
    params: {
      columnFilter: {
        // "filter[record_status]": "O",
      },
      page: -1,
    },
  });

  const {
    refetch: fetchListPhaseOrderScanActionType,
    data: listPhaseOrderScanActionType,
  } = useListPhaseOrderScanActionType({
    params: {
      columnFilter: {
        // "filter[record_status]": "O",
      },
      page: -1,
    },
  });

  useEffect(() => {
    fetchListPhaseOrderScanStatus();
    fetchListPhaseOrderScanActionType();
    fetchOrderDetailPhaseOrder();
    mutateDashboardPhaseOrderScan({ id: phaseOrderScanDetailId });
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <div className="d-md-flex justify-content-between PhaseOrderDetail">
            <div className="d-md-flex gap-3 align-items-center pb-0">
              <MetaTags>
                <title>{t("phaseOrder.titleDetail")}</title>
              </MetaTags>
              <BreadcrumbWithLink title={t("phaseOrder.titleDetail")} />
            </div>
          </div>

          <Card body className="mt-3">
            <h4 className="text-primary">
              Số lượng yêu cầu đã quét (Theo ĐVVC)
            </h4>
            {isLoadingDashboardPhaseOrderScan ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <DonutChart data={dashboardData} />
            )}
          </Card>

          <Card body className="mt-3">
            <div className="d-flex gap-2">
              <h4 className="text-primary">Thông tin đợt quét kiện</h4>
              <h4 className="text-success">
                ( Tổng kiện đã quét: {dataDetailPhaseOrder?.total})
              </h4>
              {dataDetailPhaseOrder?.action_type === "scan_send" && (
                <h4
                  className="text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate(`/manage-new-send-order-scan-total`);
                  }}
                >
                  ( Số đơn trả kết quả chưa quét:{" "}
                  {dataDetailPhaseOrder?.newSendOrderScanTotal})
                </h4>
              )}
            </div>
            <Row xs={1} md={4}>
              <Col>
                <Label htmlFor="customers">Tên</Label>
                <Input
                  id="PhaseName"
                  type="text"
                  value={dataDetailPhaseOrder?.name || ""}
                  readOnly
                />
              </Col>
              <Col>
                <Label htmlFor="customers">Trạng thái</Label>
                <Input
                  id="PhaseStatus"
                  type="text"
                  value={
                    listPhaseOrderScanStatus?.[dataDetailPhaseOrder?.status] ||
                    ""
                  }
                  readOnly
                />
              </Col>
              <Col>
                <Label htmlFor="customers">Loại quét kiện</Label>
                <Input
                  id="PhaseActionType"
                  type="text"
                  value={
                    listPhaseOrderScanActionType?.[
                      dataDetailPhaseOrder?.action_type
                    ] || ""
                  }
                  readOnly
                />
              </Col>
            </Row>
            <Row xs={1} md={4} className="mt-2">
              <Col>
                <Label htmlFor="customers">Thời gian bắt đầu</Label>
                <Input
                  id="PhaseStartDate"
                  type="text"
                  value={
                    dataDetailPhaseOrder?.start_date
                      ? new Intl.DateTimeFormat("en-GB", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                        }).format(
                          Number(dataDetailPhaseOrder?.start_date) * 1000
                        )
                      : ""
                  }
                  readOnly
                />
              </Col>
              <Col>
                <Label htmlFor="customers">Thời gian kết thúc</Label>
                <Input
                  id="PhaseEndDate"
                  type="text"
                  value={
                    dataDetailPhaseOrder?.end_date
                      ? new Intl.DateTimeFormat("en-GB", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                        }).format(Number(dataDetailPhaseOrder?.end_date) * 1000)
                      : ""
                  }
                  readOnly
                />
              </Col>
              <Col>
                <Label htmlFor="customers">Người bắt đầu quét</Label>
                <Input
                  id="PhaseStarter"
                  type="text"
                  value={dataDetailPhaseOrder?.starter?.display_name || ""}
                  readOnly
                />
              </Col>
              <Col>
                <Label htmlFor="customers">Người kết thúc quét</Label>
                <Input
                  id="PhaseFinisher"
                  type="text"
                  value={dataDetailPhaseOrder?.finisher?.display_name || ""}
                  readOnly
                />
              </Col>
            </Row>
          </Card>

          <Card body className="mt-3">
            <ListHistoryScan
              isShowListOnly={true}
              scanId={phaseOrderScanDetailId}
            />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PhaseOrderDetailPage;
